import { useMemo } from "react";
import { matchRoutes, useLocation } from "react-router-dom";
import { ADMIN_ROUTES, NAV_GROUPS, type AdminRoute, type NavGroup } from "@/navigation/registry";

const matchable = ADMIN_ROUTES.map((r) => ({ path: r.path }));
const byPath = new Map(ADMIN_ROUTES.map((r) => [r.path, r]));

export type ActiveRoute = {
  route?: AdminRoute;
  /** The sidebar link that should be highlighted. */
  navRoute?: AdminRoute;
  group?: NavGroup;
};

export const resolveActiveRoute = (pathname: string): ActiveRoute => {
  const matches = matchRoutes(matchable, pathname);
  const route = matches?.length ? byPath.get(matches[matches.length - 1].route.path) : undefined;
  if (!route) return {};
  const navRoute = route.nav ? route : route.parent ? byPath.get(route.parent) : undefined;
  const group = NAV_GROUPS.find((g) => g.id === navRoute?.nav?.group);
  return { route, navRoute, group };
};

export const useActiveRoute = (): ActiveRoute => {
  const { pathname } = useLocation();
  return useMemo(() => resolveActiveRoute(pathname), [pathname]);
};
